import {UFOExperience as $2HUwk$UFOExperience, ExperiencePerformanceTypes as $2HUwk$ExperiencePerformanceTypes, ExperienceTypes as $2HUwk$ExperienceTypes} from "@atlassian/ufo";
import $2HUwk$atlassianufoloadhold from "@atlassian/ufo-load-hold";
import $2HUwk$atlassianufosegment from "@atlassian/ufo-segment";


const $86f78d73d695fe3a$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $86f78d73d695fe3a$export$6d482cfa20c9d220 = 'post-office';


class $d6462931766f6907$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $2HUwk$UFOExperience)((0, $86f78d73d695fe3a$export$cc7ddf8ca628f6f1).MESSAGE, {
            performanceType: (0, $2HUwk$ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $2HUwk$ExperienceTypes).Load,
            platform: {
                component: (0, $86f78d73d695fe3a$export$6d482cfa20c9d220)
            }
        });
        this.messageSpecificExperience = new (0, $2HUwk$UFOExperience)(`${(0, $86f78d73d695fe3a$export$cc7ddf8ca628f6f1).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $2HUwk$ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $2HUwk$ExperienceTypes).Load,
            platform: {
                component: (0, $86f78d73d695fe3a$export$6d482cfa20c9d220)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}




const $3043e7d73b856a84$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $3043e7d73b856a84$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $2HUwk$ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $2HUwk$ExperienceTypes).Load,
    platform: {
        component: (0, $86f78d73d695fe3a$export$6d482cfa20c9d220)
    },
    timings: [
        {
            key: `${$3043e7d73b856a84$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$3043e7d73b856a84$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$3043e7d73b856a84$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$3043e7d73b856a84$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$3043e7d73b856a84$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$3043e7d73b856a84$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$3043e7d73b856a84$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$3043e7d73b856a84$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $3043e7d73b856a84$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$3043e7d73b856a84$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$3043e7d73b856a84$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$3043e7d73b856a84$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $3043e7d73b856a84$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $3043e7d73b856a84$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$3043e7d73b856a84$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $3043e7d73b856a84$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $2HUwk$UFOExperience)((0, $86f78d73d695fe3a$export$cc7ddf8ca628f6f1).PLACEMENT, $3043e7d73b856a84$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $2HUwk$UFOExperience)(`${(0, $86f78d73d695fe3a$export$cc7ddf8ca628f6f1).PLACEMENT}.${placementId}`, $3043e7d73b856a84$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}


const $03d73539963c9398$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $d6462931766f6907$export$ae5c73c7c4f454e6,
    PlacementPerformanceTracker: $3043e7d73b856a84$export$8b48c2105ba0b35a
};




const $06307d787480bd9e$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $2HUwk$atlassianufoloadhold,
    UFOSegment: $2HUwk$atlassianufosegment
};




export {$03d73539963c9398$export$96236906ebaa7f87 as UFOv1, $06307d787480bd9e$export$c91b09caa8ecbab1 as UFOv2};
//# sourceMappingURL=index.js.map
